import React from "react";
import AddTerm from "../components/AddTerm";

const Home = () => {
  return (
    <>
      <h2>Welcome</h2>
      <AddTerm />
    </>
  );
};

export default Home;
